// This is a bundled demo
// you should remove this to work on
// your own component.

import React from "react";
import propTypes from "prop-types";

// remember to also remove the bundled demo CSS files
// from ../styles

import styles from "../styles/eldo-component.css";
import Accordion from "./accordion";

export default class EldoComponent extends React.Component {
  render() {
    const data = this.props.data;

    return (
      <div className={styles.container}>
        <h4>Demo Electrode Component</h4>
        {data.map((d, x) => <Accordion key={x} summary={d.summary} details={d.details} />)}
      </div>
    );
  }
}

EldoComponent.displayName = "EldoComponent";

EldoComponent.propTypes = {
  data: propTypes.array
};

EldoComponent.defaultProps = { };



// WEBPACK FOOTER //
// ./src/components/eldo-component.jsx